"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractError = exports.extractData = exports.errorHandler = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var moment_1 = tslib_1.__importDefault(require("moment"));
var tokenStorage_1 = tslib_1.__importDefault(require("./lib/tokenStorage"));
var SIXTY_SECONDS = 60000;
var axiosInstance = axios_1.default.create({
    timeout: SIXTY_SECONDS,
    responseType: 'json',
    headers: {
        utcoffset: (0, moment_1.default)().utcOffset() / 60,
    },
});
axiosInstance.interceptors.request.use(function (config) {
    var token = tokenStorage_1.default.get();
    if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
}, function (error) {
    Promise.reject(error);
});
// unwrap the response data for all requests, no need to do it manually every time
axiosInstance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var cleanError = (error.response && error.response.data) || error;
    handleInvalidToken(cleanError);
    return Promise.reject(error);
});
exports.default = axiosInstance;
function errorHandler(errorResponse) {
    var error = (0, get_1.default)(errorResponse, 'response.data', errorResponse);
    throw error;
}
exports.errorHandler = errorHandler;
function extractData(response) {
    if (response.data === undefined)
        return response;
    return response.data;
}
exports.extractData = extractData;
function extractError(errorResponse) {
    var error = (0, get_1.default)(errorResponse, 'response.data', errorResponse);
    return error;
}
exports.extractError = extractError;
// If we ever get the invalid token error handle it here by removing the token
function handleInvalidToken(error) {
    if (error && error.statusCode === 401 && error.message === 'Invalid token format') {
        tokenStorage_1.default.clear();
    }
}
